// extracted by mini-css-extract-plugin
export default {"nav":"components_nav__sA-5U","navactive":"components_navactive__Zk007","link":"components_link__PMwxY"};